import Vue from 'vue';
import VModal from 'vue-js-modal';

import App from '@/App.vue';
import { installFocusDirective } from '@/directives/focus';
import router from '@/router';

import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faBars,
  faUser as faUserSolid,
  faUserSecret,
  faTimes,
  faPen
} from '@fortawesome/free-solid-svg-icons';
import { faUser as faUserRegular } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

library.add(faUserSolid, faUserRegular, faUserSecret, faBars, faTimes, faPen);

Vue.component('font-awesome-icon', FontAwesomeIcon);

Vue.config.productionTip = false;

Vue.use(VModal, {
  dynamic: true,
  injectModalsContainer: true
});
installFocusDirective();

new Vue({
  router,
  render: h => h(App)
}).$mount('#app');
